import "primeicons/primeicons.css"; //icons
import { Menu as NewMenu } from 'primereact/menu';
import { ScrollPanel } from 'primereact/scrollpanel';
import { Card } from "primereact/card";
import "primereact/resources/primereact.min.css"; //core css
import "primereact/resources/themes/lara-light-indigo/theme.css"; //theme
import React, { useEffect, useState } from 'react';
import "./Menu.css";
import useWindowDimensions from "../hooks/useDimensions.js";
import { useHistory } from "react-router-dom";
import './ScrollPanelDemo.css';
import { PanelMenu } from "primereact/panelmenu";
import { InputText } from 'primereact/inputtext';
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { template } from "lodash";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : Menu
Description : Menú que se depliega al interacturar con el botón burger
Date Autor Modification
================================================================================
26/10/2021 Santiago Coca Rojas – Se implementa el menú desde cero.
02/03/2022 Santiago Coca Rojas Documentación - Se documenta el componente teniendo los cambios realizados con PrimeReact
================================================================================ */

function Menu({ open, setOpen }) {
    /*Elementos y rutas del menú*/

    const { height, width } = useWindowDimensions()
    const [newItems, setNewItems] = useState([])
    const [disableAnimation, setDisableAnimation] = useState(false);
    const [expandedKeys, setExpandedKeys] = useState({});
    const [search, setSearch] = useState("")
    const [filteredItems, setFilteredItems] = useState([])
    let history = useHistory();

    useEffect(() => {
        // if (newItems.length < 1) {
        console.log("Se abre el menú")
        setMenu()
        // }
    }, [localStorage.getItem('options_web')]);

    useEffect(() => {
        setDisableAnimation(true);
        setSearch("")
        const timer = setTimeout(() => setDisableAnimation(false), 300);
        return () => clearTimeout(timer);
    }, [window.location.pathname]);

    useEffect(() => {
        const input = document.querySelector('#buscar1t');
        setTimeout(() => {
            if (input) input.setAttribute('autocomplete', 'off');
        }, 100);
    }, []);

    const closeMenu = () => {
        if (width <= 919) {
            setOpen(!open)
        }
        if (localStorage.getItem('kiosco')) {
            setOpen(false)
        }
    }

    const handleNavigation = (path, event) => {
        console.log(event)
        console.log(path)
        if (event.type === "contextmenu") return;

        if (event.ctrlKey || event.metaKey || event.button === 1) {
            window.open(path, "_blank");
        } else {
            event.preventDefault();
            history.replace(path);
            // closeMenu();
        }
    };

    const menuTemplate = (item, options) => {
        return (
            <a
                href={item.route}
                onClick={(event) => handleNavigation(item.route, event)}
                onContextMenu={(event) => handleNavigation(item.route, event)}
                className={options.className}
                style={{ display: "flex", alignItems: "center", textDecoration: "none", color: "inherit" }}
            >
                <span className={item.icon} style={{ marginRight: "8px" }}></span>
                <span>{item.label}</span>
            </a>
        );
    };

    const itemStyle = {
        color: "black",
        marginLeft: "-1.7rem",
        width: '14rem'
    }

    const processMenuItems = (items) => {
        return items.map((item) => {
            console.log(item, item.type === "element")
            let newItem = {
                ...item,
                command: () => {
                    if (item.label === 'Kiosco') {
                        localStorage.setItem("kiosco", "S")
                    }
                },
                template: item.type === 'element' && menuTemplate,
                style: item.type === 'element' ? {...itemStyle, fontWeight: '400'} : {...itemStyle, fontWeight: '900'}
            }
            if (item.items) {
                newItem.items = processMenuItems(item.items)
            }

            return newItem
        })
    }

    const setMenu = () => {

        let menu = JSON.parse(localStorage.getItem('options_web'))

        if (menu) {

            const newMenu = menu.map((element, index) => ({
                ...element,
                key: index,
                items: element.items ? processMenuItems(element.items) : []
            }))

            setNewItems(newMenu)
            setFilteredItems(newMenu)

            console.log(newMenu)
        }
    }

    let styleOpen = {
        transform: "translate(0)",
        transition: "transform 0.3s ease-in-out",
        // top: width <= 768 && 20,
        height: height,
    };

    let styleClose = {
        transform: "translate(-100%)",
        transition: "transform 0.3s ease-in-out",
        // top: width <= 768 && 10,
        height: height,
        // display: 'none'
    }

    let styleOpenSearch = {
        transform: "translate(0)",
        transition: "transform 0.3s ease-in-out",
        marginBottom: "0.5rem",
        marginTop: "0.5rem",
    };

    let styleCloseSearch = {
        transform: "translate(-100%)",
        transition: "transform 0.3s ease-in-out",
        marginBottom: "0.5rem",
        marginTop: "0.5rem",
    }

    const normalizeText = (text) => {
        return text?.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    }

    const filterMenuItems = (items, search, expandedKeys, path = "") => {
        return items
            .map((item, index) => {
            const currentPath = path === "" ? `${index}` : `${path}-${index}`;

            const labelMatch = search === "" || normalizeText(item.label).includes(normalizeText(search));

            let children = [];

            if (item.items) {
                children = filterMenuItems(item.items, search, expandedKeys, currentPath);
            }

            if (labelMatch || children.length > 0) {
                if (children.length > 0) {
                    expandedKeys[currentPath] = true;
                }

                return {
                    ...item,
                    items: children.length > 0 ? children : item.items
                };
            }

            return null;
            }).filter(Boolean);
    };

    const filterItems = (busqueda) => {
        setSearch(busqueda);

        let initialExpanded = {};

        const filtered = filterMenuItems(newItems, busqueda, initialExpanded);

        if (busqueda === "") {
            initialExpanded = {};
        }

        setExpandedKeys(initialExpanded);
        setFilteredItems(filtered);
    };

    /*Renderizado del componente*/
    return (
        <div style={{ position: 'fixed', top: 50, zIndex: 1, ...(open ? styleOpen : styleClose), wordWrap: '' }} className="scrollpanel-demo">
            {/* <div className="card flex justify-content-start flex-column"> */}
            <ScrollPanel
                className={disableAnimation ? "no-animation" : "custombar1"}
                style={{
                    // ...(open ? styleOpen : styleClose),
                    marginTop: !localStorage.getItem("logo") || width < 676 ? '0' : '1rem',
                    height: height + 5,
                    width: "14rem",
                    textAlign: 'left !important',
                    // display: 'flex',
                    // flexWrap: 'wrap'
                }}>
                {/* <Card className={open ? 'pm mobile-shadow' : 'pm'}> */}
                <InputText type="text" style={{ display: 'none' }} autoComplete="off" />

                <form onLoad={(e) => e.target.reset()} >
                    <IconField iconPosition="left" style={{ ...(open ? styleOpenSearch : styleCloseSearch), width: "14rem" }}>
                        <InputIcon className="pi pi-search" />
                        <InputText type="text" value={search} onChange={(e) => filterItems(e.target.value)} placeholder="Buscar"
                            style={{ width: "100%" }} name={`input-${Math.random()}`} id="buscar1" />
                    </IconField>
                </form>
                <PanelMenu multiple className="panel"
                    expandedKeys={expandedKeys} model={filteredItems}
                    onExpandedKeysChange={(e) => setExpandedKeys(e.value)}
                    style={{
                        marginTop: '-0.5rem',
                        // marginLeft: '1rem',
                        width: '14rem',
                        // border: 'none',
                        // zIndex: "999 !important",
                        marginBottom: "4rem",
                        // marginLeft: '-0.2rem'
                    }}
                />
                {/* </Card>*/}
            </ScrollPanel>
            {/* </div> */}
        </div>
    );
}

export default Menu;